import { useContext } from 'react';

import { CatalogDataContextV2 } from './CatalogDataContext.types';

export const useCatalogDataContext = () => {
  // This seems like a pointless wrapper, but this is for if we need to test Catalog vNext, we'd add it here
  // For example:
  // return useContext(CatalogDataContextV3);

  return useContext(CatalogDataContextV2);
};
